<template>
  <tr>
    <td>
      <router-link :to="`${urlPrefix}/posts/${serviceId}/${post.slug}`">
        <span v-if="post.title">{{ post.title }}</span>
        <span v-else-if="post.body">{{ post.body | substr(20) }}</span>
      </router-link>
    </td>
    <td
      class="is-size-7"
      v-text="getCategoryLabel(post.categorySlug)"
    ></td>
    <td v-if="hasEditorRole">
      <router-link
        :to="`/admin/posts/${serviceId}/${post.postId}/edit`"
        class="button is-small"
      >
        <span class="icon is-small">
          <i class="fas fa-pen"></i>
        </span>
      </router-link>
    </td>
    <td
      v-if="isAdmin"
      class="is-size-7"
    >
      <inline-time :datetime="post.createdAt"></inline-time>
    </td>
    <td
      v-if="!isAdmin"
      class="has-text-centered"
    >
      <span
        v-if="isMastered"
        class="icon is-small has-text-success"
      >
        <i class="fas fa-check-circle"></i>
      </span>
    </td>
  </tr>
</template>
<script>
import InlineTime from '@/components/atoms/InlineTime'

export default {
  name: 'PostsTableRow',

  components: {
    InlineTime,
  },

  props: {
    post: {
      type: Object,
      default: null,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    isMastered: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    categoryLabel() {
      if ('category' in this.post === false) return '-'
      if (this.checkEmpty(this.post.category)) return '-'
      if (this.checkEmpty(this.post.category.label)) return '-'
      return this.post.category.label
    },

    urlPrefix() {
      if (this.isAdmin) return '/admin'
      return ''
    },
  },

  watch: {},

  created() {},

  methods: {},
}
</script>
